export default "__VITE_ASSET__DgcKSRDI__"